import { IClipBoardElement, IElement } from 'routes/private/Editor/types';

export const addElement = (parentElement: IElement, elementToAdd: Partial<IClipBoardElement>): IElement => {
  const newElement = elementToAdd.element!;
  if (parentElement.children) parentElement.children.push(newElement);
  else parentElement.children = [newElement];
  if (elementToAdd.setName) {
    parentElement.children = parentElement.children?.map(element => {
      element.attributes.hidden = element.name === elementToAdd.setName ? false : true;
      return element;
    })
  }
  return parentElement;
}
